/* eslint-disable unicorn/prevent-abbreviations */
import { IScope, ICompileService } from 'angular';
import APIV5 from '~/models/api';
import buttons from './data-table/actions-buttons.html';

export default class {
	/**
	 * @param {IScope} $scope
	 * @param {ICompileService} $compile
	 */
	/* @ngInject */
	constructor($scope, $compile) {
		this.$scope = $scope;
		this.$compile = $compile;

		this.isLoading = true;
		this.table = null;
		this.columns = [
			{
				title: 'Nom',
				field: 'name',
			},
			{
				title: 'Type',
				field: 'type',
			},
			{
				title: 'Date',
				field: 'date',
			},
			{
				title: 'Workflow',
				field: 'workflow',
			},
			{
				title: 'Actions',
				width: 150,
				formatter: cell => this.printIcon(cell),
				hozAlign: 'center',
			},
		];

		this.options = {
			movableColumns: true,
			layout: 'fitColumns',
			placeholder: 'Aucune donnée disponible',
			height: 500,
			selectable: 'highlight',
		};

		this.$onInit();
	}

	// eslint-disable-next-line class-methods-use-this
	delete(cell) {
		// eslint-disable-next-line no-console
		console.log('cell', cell);
	}

	// eslint-disable-next-line class-methods-use-this
	edit(cell) {
		// eslint-disable-next-line no-console
		cell.console.log('cell', cell);
	}

	// eslint-disable-next-line class-methods-use-this
	printIcon(cell) {
		const index = cell.getRow().getPosition();

		const scope = this.$scope.$new(false, this.$scope);
		scope.$ctrl = {
			...this,
			cell: index,
		};
		// eslint-disable-next-line no-console
		console.log('scope', scope);
		const compiled = this.$compile(buttons)(scope).get(0);
		// eslint-disable-next-line no-console
		console.log('compiled', compiled);
		return compiled;
	}

	// eslint-disable-next-line class-methods-use-this
	async $onInit() {
		const { result } = await APIV5.instance.raw('Extract', {
			extract: {
				filter: [],
				search_kid: 'K_NODE;PERSON',
			},
			packet_index: 1,
			packet_size: 50,
		});

		const {
			rows,
		} = result;

		const data = [];
		for (const [index, row] of rows.entries()) {
			let myRow = {};
			for (const element of row) {
				const {
					name, datecreation, isa, wf,
				} = element;

				myRow = {
					index,
					name,
					type: isa,
					date: datecreation,
					workflow: wf.count,
				};
			}
			// console.log('myRow', myRow);
			data.push(myRow);
		}

		this.data = data;
		// eslint-disable-next-line no-console
		console.log('this.data', this.data);
		this.isLoading = false;
		this.table.setColumns(this.columns);
		this.table.replaceData(this.data);
	}
}
